class floatingCart extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange();
    this.height = this.clientHeight;
    document.body.style.paddingBottom = `${this.height}px`;
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  reveal() {
    this.setAttribute('animate', '');
  }

  reset() {
    this.removeAttribute('animate');
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while(element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
  onScroll() {
    let atcObserver = new IntersectionObserver( (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          requestAnimationFrame(this.reset.bind(this));
        } else {
          requestAnimationFrame(this.reveal.bind(this));
        }
      });
    })
    atcObserver.observe(document.querySelector('.pdp-btns-wrapper'));
    // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // if (scrollTop > this.getOffsetTop(this)) {
    //     requestAnimationFrame(this.reveal.bind(this));
    // } else {
    //     requestAnimationFrame(this.reset.bind(this));
    // }
  }
  reveal() {
    this.setAttribute('animate', '');
  }
  reset() {
    this.removeAttribute('animate');
  }

  onVariantChange = () => {
    document.addEventListener('variant:change', (vardata) => {
      console.log(vardata.detail);
      this.querySelector('.var-title').textContent = vardata.detail.variant?.title;
      let atcBtn = this.querySelector('[name="add"]');
      if (atcBtn) {
        if (vardata.detail.variant.available == false) {
          atcBtn.textContent = theme.strings.soldOut;
          atcBtn.disabled = true;
        } else {
          atcBtn.textContent = theme.strings.addToCart;
          atcBtn.disabled = false;
        }
      }
    })
  }

}
customElements.define('floating-cart',floatingCart)